module.exports = __webpack_public_path__ + "static/media/team-scharmfang.84322e0e.jpg";